module.exports = __webpack_public_path__ + "img/lying-girl.2bda1ae.svg";